// ═══════════════════════════════════════════════════════════════
// AGENCIAS · LIVE FEST (model.js)
// La sección «LIVE FEST» del menú lateral de la consola de agencias
// (28-oct-2026, Javier): una pantalla de «lo estamos preparando» con su
// cuenta atrás. Se enciende y se apaga desde el backoffice (Agencias →
// LIVE FEST), que también pone la fecha de la cuenta atrás. Se guarda en D1
// app_config['agency_live_fest'] y la app lo lee de GET /api/agency/live-fest.
//
// Modelo ÚNICO: lo cargan tal cual la app (owner-console/index.js), el
// backoffice (lib/agencyLiveFest.js) y el Worker (cf-worker/src/lib/
// agencyLiveFest.js). Qué se puede guardar lo decide sanitize() y nadie más.
//   { enabled: boolean, startsAt: ms | null }
// TikControl © 2024-2026
// ═══════════════════════════════════════════════════════════════

(function (root) {
  'use strict';

  // Una fecha de cuenta atrás que tenga sentido (ni 1970 ni el año 3000).
  const MIN_TS = Date.UTC(2024, 0, 1);
  const MAX_TS = Date.UTC(2100, 0, 1);
  const DAY = 864e5, HOUR = 36e5, MIN = 6e4;

  /** Lo guardado (o lo que llega) → { enabled, startsAt }. Nunca lanza. */
  function sanitize(raw) {
    const r = raw && typeof raw === 'object' ? raw : {};
    const at = Math.round(Number(r.startsAt));
    return {
      enabled: r.enabled === true,
      startsAt: Number.isFinite(at) && at >= MIN_TS && at < MAX_TS ? at : null,
    };
  }

  /** ¿Apagado y sin fecha? Entonces no hace falta guardar nada. */
  function isFactory(config) {
    const c = sanitize(config);
    return !c.enabled && c.startsAt == null;
  }

  /**
   * Lo que falta hasta startsAt, en días, horas, minutos y segundos.
   * null si no hay fecha; done: true cuando ya ha llegado.
   */
  function countdown(startsAt, now) {
    const at = Number(startsAt);
    if (!Number.isFinite(at) || at <= 0) return null;
    const left = Math.max(0, at - (Number(now) || 0));
    // Se cuenta por segundos enteros hacia arriba: con 1,4 s quedan «1» hasta
    // que llega a 0 de verdad (no se ve 00:00:00 un segundo antes de tiempo).
    const secs = Math.ceil(left / 1000);
    return {
      done: secs <= 0,
      total: secs * 1000,
      days: Math.floor(secs * 1000 / DAY),
      hours: Math.floor((secs * 1000 % DAY) / HOUR),
      minutes: Math.floor((secs * 1000 % HOUR) / MIN),
      seconds: secs % 60,
    };
  }

  root.AgenciasLiveFestModel = { sanitize, isFactory, countdown, MIN_TS, MAX_TS };
})(typeof globalThis !== 'undefined' ? globalThis : window);
